'use client';

import { useEffect } from 'react';
import CustomError from '@/views/error';
import { reportFrontendError } from '@/lib/frontend-error-reporter';

const Error = ({ error }: { error: Error & { digest?: string } }) => {
  useEffect(() => {
    reportFrontendError(error, { source: 'react-boundary', digest: error.digest });
  }, [error]);
  return <CustomError message="페이지를 열 수 없습니다." />;
};

export default Error;
